import axios from '../../../Utils/axios';
import unAuthAxios from '../../../Utils/unAuthAxios';
import { getURL } from './commonApi';

const globals = require('../../../config/' +
  process.env.REACT_APP_STAGE +
  '/Portal/globals');

// 공지사항 목록 조회
const getAdvisoryList = (param) => {
  const url = getURL(`${globals.commonApiUrl}/advisory`, param);

  return unAuthAxios.get(url).then((response) => {
    return response;
  });
};

// 공지사항 상세 정보 조회
const getAdvisoryDetail = (param) => {
  const url = getURL(
    `${globals.commonApiUrl}/advisory/${param.systemCode}/${param.advisoryNo}`
  );

  return unAuthAxios.get(url).then((response) => {
    return response;
  });
};

// 공지사항 등록
const setAdvisory = (param) => {
  const url = getURL(`${globals.commonApiUrl}/advisory`);

  return axios.post(url, param).then((response) => {
    return response;
  });
};

// 게시판 목록 조회
const getBoardPostList = (param) => {
  const url = getURL(`${globals.commonApiUrl}/board/post`, param);

  return unAuthAxios.get(url).then((response) => {
    return response;
  });
};

// 게시판 목록 조회
const getBoardPostDetail = (param) => {
  const url = getURL(
    `${globals.commonApiUrl}/board/post/${param.boardPostNo}`,
    param
  );

  return unAuthAxios.get(url).then((response) => {
    return response;
  });
};

// boardPost 등록
const setBoardPost = (param) => {
  const url = getURL(`${globals.commonApiUrl}/board/post`);

  return axios.post(url, param).then((response) => {
    return response;
  });
};

export default {
  getAdvisoryList,
  getAdvisoryDetail,
  setAdvisory,
  getBoardPostList,
  getBoardPostDetail,
  setBoardPost,
};
